<nx-ng-loader text="{{ 'post_login_loading' | i18next }}"></nx-ng-loader>
